/** @jsxImportSource @emotion/react */

import React from 'react'
import PropTypes from 'prop-types'
import { Title, noMarginTop } from './styles'

export default function CardTitle({ title, noMargin }) {
  return (
    <Title css={noMargin ? noMarginTop : null}>
      {title}
    </Title>
  )
}

CardTitle.propTypes = {
  title: PropTypes.string.isRequired,
  noMargin: PropTypes.bool,
}

CardTitle.defaultProps = {
  noMargin: false,
}
